// @flow
import RadioSelect from 'fg-frontend/src/components/RadioSelect';
import CheckboxSelect from 'fg-frontend/src/components/CheckboxSelect';
import Slider from 'fg-frontend/components/Slider';
import NumberInput from 'fg-frontend/components/NumberInput';
import SimpleCollapse from 'fg-frontend/components/SimpleCollapse';
import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
import ListToggle from 'fg-frontend/components/ListToggle';
import Typeahead from 'fg-frontend/components/Typeahead';
// import FulltextAutocomplete from 'fg-frontend/components/FulltextAutocomplete';
import PasswordToggle from 'fg-frontend/components/PasswordToggle';
import SocialShare from 'fg-frontend/components/SocialShare';
// import RangeDatepicker from 'fg-frontend/components/RangeDatepicker';
import AnchorsList from 'fg-frontend/src/components/AnchorsList';
import RadioSelectTab from 'fg-frontend/src/components/RadioSelectTab';
//import GreedyMenu from 'fg-frontend/components/GreedyMenu';
import ShareUrl from 'fg-frontend/src/components/ShareUrl';
// import PrintPage from 'fg-frontend/src/components/PrintPage';
// import PrintPdf from 'fg-frontend/src/components/PrintPdf';
import RedirectToUrl from 'fg-frontend/src/components/RedirectToUrl';

import SvgIcons from './components/SvgIcons';
import Webslider from './components/Webslider';
import SelectDesign from './components/SelectDesign';
import Tooltip from './components/Tooltip';
import Calendar from './components/Calendar';
// import CalendarSort from './components/CalendarSort';
import StyleGuideSnippet from './components/StyleGuideSnippet';
import GtmHandler from './components/GtmHandler';
import TriggerInViewport from './components/TriggerInViewport';
import GoogleMap from './components/GoogleMap';
import PhotoSwipe from './components/PhotoSwipe';
import StudyFieldsSort from './components/StudyFieldsSort';
import FulltextSearch from './components/FulltextSearch';
import AjaxFulltextFilter from './components/AjaxFulltextFilter';
import LazyImage from './components/LazyImage';
import OfficialBoardList from './components/OfficialBoardList';
import HtmlForm from './components/HtmlForm';
import GoogleRecaptcha from 'fg-frontend/src/components/GoogleRecaptcha';
import SignLanguageVideos from './components/SignLanguageVideos';
import FacultySelect from './components/FacultySelect';
import ScramjetPuHandler from './components/ScramjetPuHandler';
import ToggleClass from './components/ToggleClass';
import TinyMceEditor from './components/TinyMceEditor';
import ForumTopicPost from './components/ForumTopicPost';
import ForumAnswerActions from './components/ForumAnswerActions';
import ForumUpdateActions from './components/ForumUpdateActions';
import ForumRemoveActions from './components/ForumRemoveActions';
import ForumSearchHighlight from './components/ForumSearchHighlight';
import ForumSearch from './components/ForumSearch';
import ForumAnchor from './components/ForumAnchor';
// COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
import PreventDoubleClickHandler from 'fg-frontend/src/components/PreventDoubleClickHandler';
import configureEshopComponents from './configureEshopComponents';
// COMMON: Komponenta pro sestavení subnavigace na Help pointu
import SecondaryNavigation from './components/SecondaryNavigation';
// COMMON: Komponenta pro prepinani HTML tridy na danem elementu
import Toggler from './components/Toggler';

export default (props) => {
	switch (props.decorator || props.is) {
    case 'SvgIcons':
      return SvgIcons;
		case 'RadioSelect':
			return RadioSelect;
		case 'CheckboxSelect':
			return CheckboxSelect;
		case 'SimpleCollapse':
			return SimpleCollapse;
		/*case 'GreedyMenu':
			return GreedyMenu;*/
		case 'Typeahead':
			return Typeahead;
		case 'SelectDesign':
			return SelectDesign;
		case 'ListToggle':
			return ListToggle;
		case 'PasswordToggle':
			return PasswordToggle;
		case 'SocialShare':
			return SocialShare;
		case 'Webslider':
			return Webslider;
		case 'AnchorsList':
			return AnchorsList;
		case 'FulltextSearch':
		  return FulltextSearch;
		case 'AjaxFulltextFilter':
      		return AjaxFulltextFilter;
		case 'Slider':
			return Slider;
		case 'RadioSelectTab':
			return RadioSelectTab;
		case 'NumberInput':
			return NumberInput;
		case 'UniversalPaginationButton':
			return UniversalPaginationButton;
		case 'Tooltip':
			return Tooltip;
		case 'StudyFieldsSort':
		  return StudyFieldsSort;
		case 'Calendar':
			return Calendar;
        // case 'CalendarSort':
        //     return CalendarSort;
        case 'GoogleMap':
            return GoogleMap;
		case 'StyleGuideSnippet':
			return StyleGuideSnippet;
		case 'PhotoSwipe':
			return PhotoSwipe;
		case 'LazyImage':
		  return LazyImage;
		case 'GtmHandler':
		  return GtmHandler;
		case 'TriggerInViewport':
		  return TriggerInViewport;
        case 'ShareUrl':
            return ShareUrl;
        case 'RedirectToUrl':
            return RedirectToUrl;
        case 'OfficialBoardList':
            return OfficialBoardList;
		case 'HtmlForm':
			return HtmlForm;
		case 'GoogleRecaptcha':
			return GoogleRecaptcha;
		case 'SignLanguageVideos':
			return SignLanguageVideos;
		case 'FacultySelect':
			return FacultySelect;
		case 'ScramjetPuHandler':
			return ScramjetPuHandler;
		case 'ToggleClass':
			return ToggleClass;
		case 'SecondaryNavigation':
			return SecondaryNavigation;
		case 'Toggler':
			return Toggler;
		case 'TinyMceEditor':
      		return TinyMceEditor;
		case 'SlickSlider':
			return import('./components/SlickSlider');
	case 'ForumTopicPost':
      return ForumTopicPost;
    case 'ForumAnswerActions':
      return ForumAnswerActions;
    case 'ForumUpdateActions':
      return ForumUpdateActions;
    case 'ForumRemoveActions':
      return ForumRemoveActions;
    case 'ForumSearchHighlight':
      return ForumSearchHighlight;
    case 'ForumSearch':
      return ForumSearch;
    case 'ForumAnchor':
      return ForumAnchor;
    case 'PreventDoubleClickHandler':
      return PreventDoubleClickHandler;
    default:
			const eshopComponent = configureEshopComponents(props);
			if (eshopComponent) {
				return eshopComponent;
			}
			else {
				console.log(`Unknown component ${props.decorator || props.is}`);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js